var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"b-link",class:{
    ['b-link--minor']: _vm.minor,
    ['b-link--light']: _vm.$voicer.isLightTheme && !_vm.primary,
    ['b-link--dark']: _vm.$voicer.isDarkTheme && !_vm.primary,
    'primary--text': _vm.primary,
  },attrs:{"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }